import { useEffect } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { useAppSelector } from 'src/hooks';
import Storage from 'src/utils/storage/storage';

const CountryParamHandler = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  // Fetch countryCode from Redux store first
  const { source_name } = useAppSelector((state) => state.landing.segmentDetailsData) || {};

  const getCountryCode = () => {
  let code = source_name?.trim()?.replace(/\s+/g, '');
    // If Redux store does not have code, fallback to Storage
  if (!code) {
    const segmentDetails = Storage.getSegmentDetails();
    code = segmentDetails?.source_name?.trim()?.replace(/\s+/g, '');
  }
    return code
  }

  let countryCode = getCountryCode();

  useEffect(() => {
    const currentCountryCode = searchParams.get('country');

    if (countryCode && currentCountryCode !== countryCode) {
      const newSearchParams = new URLSearchParams(searchParams);
      newSearchParams.set('country', countryCode);
      navigate(`${location.pathname}?${newSearchParams.toString()}`, { replace: true });
    }
  }, [location.pathname, searchParams, countryCode]);

  return children;
};

export default CountryParamHandler;
